module.exports = __webpack_public_path__ + "img/강남역 미용실 2.dc113b8b.png";